module.exports = __webpack_public_path__ + "static/smsm-e2d68c637af5c71b99a606db21276d04.png";